import { useContext } from "react";
import { RoomContext } from "../RoomContextProvider";

const useRoomContext = () => useContext(RoomContext);

export default useRoomContext;
